import type {SearchCriteriaRaw} from '../../../types';
import {createContentsRule} from '../contentsRule';
import type {ContentsRule, TSearchTypeContents} from '../types';

export type RawContentsSearchCriteria = SearchCriteriaRaw<TSearchTypeContents>;

export const rawContentsCriteriaToRuleObject = (
	criteria: RawContentsSearchCriteria,
): ContentsRule => {
	return createContentsRule({
		contents: criteria.value1,
		type: criteria.subtype1,
	});
};

export default rawContentsCriteriaToRuleObject;
